export const imgToImage = (domNode) => {
    const { src, 'data-id': id } = (domNode === null || domNode === void 0 ? void 0 : domNode.attribs) || {};
    if (!src)
        return undefined;
    return {
        id,
        downloadUrl: src,
        url: src,
        cropX: 0,
        cropY: 0,
        cropZoom: 1,
    };
};
//# sourceMappingURL=utils.js.map